<template>
    <svg v-if="!state" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="m23.198 21.79-5.827-5.83a9.47 9.47 0 0 0 2.119-5.97C19.49 4.76 15.232.5 9.995.5 4.758.5.5 4.76.5 10s4.258 9.5 9.495 9.5c2.259 0 4.338-.8 5.967-2.12l5.826 5.83c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41l-.01-.01zM1.499 10c0-4.69 3.808-8.5 8.496-8.5 4.687 0 8.495 3.81 8.495 8.5 0 4.69-3.808 8.5-8.495 8.5-4.688 0-8.496-3.81-8.496-8.5z"
        />
    </svg>
    <svg v-else width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#06sdr4f40a)">
            <path
                d="m23.198 21.79-5.827-5.83a9.47 9.47 0 0 0 2.119-5.97C19.49 4.76 15.232.5 9.995.5 4.758.5.5 4.76.5 10s4.258 9.5 9.495 9.5c2.259 0 4.338-.8 5.967-2.12l5.826 5.83c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41l-.01-.01zM1.499 10c0-4.69 3.808-8.5 8.496-8.5 4.687 0 8.495 3.81 8.495 8.5 0 4.69-3.808 8.5-8.495 8.5-4.688 0-8.496-3.81-8.496-8.5zM4 10c0-3.31 2.688-6 5.996-6a6.003 6.003 0 0 1 5.997 6c0 3.31-2.689 6-5.997 6a6.003 6.003 0 0 1-5.997-6z"
            />
        </g>
        <defs>
            <clipPath id="06sdr4f40a">
                <path d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>
</template>

<script setup>
import { useState, stateProps } from '../../composables/useState';
const props = defineProps({ ...stateProps() });
const { state } = useState(props);
</script>
